define ['./404.scss'], () ->
  ($scope, $state, RentappService) ->



// WEBPACK FOOTER //
// ./components/home/404/404.coffee